export const ChatBubble = {
  el: {
    chatbubble: document.querySelector('.chatbubble'),
    button: document.querySelector('.chatbubble__button'),
    content: document.querySelector('.chatbubble__content'),
    chat: document.querySelector<HTMLElement>('.chat'),
    liveChatTrigger: document.querySelector<HTMLElement>('#livechat__trigger'),
  },

  init() {
    if (this.el.button && this.el.content) {
      this.el.button.addEventListener('click', () => {
        this.el.content.classList.toggle('hidden')
        setTimeout(() => {
          this.el.content.classList.toggle('chatbubble__content--active')
          this.el.button.classList.toggle('chatbubble--active')
        }, 0)
      })

      document.addEventListener('click', (e) => {
        const isClickInside = this.el.chatbubble.contains(e.target)
        if (!isClickInside) {
          this.el.content.classList.add('hidden')
          this.el.content.classList.remove('chatbubble__content--active')
          this.el.button.classList.remove('chatbubble--active')
        }
      })

      const onVisibilityChanged = (data) => {
        switch (data.visibility) {
          case 'maximized':
            this.el.chat.style.zIndex = '3'
            break
          case 'minimized':
            this.el.chat.style.zIndex = '2147483640'
            break
          case 'hidden':
            break
        }
      }

      //@ts-ignore
      // LC_API.open_chat_window();
      //@ts-ignore
      LiveChatWidget.on('visibility_changed', onVisibilityChanged)

      if (this.el.liveChatTrigger) {
        this.el.liveChatTrigger.addEventListener('click', () => {
          const livechatOpen = this.el.liveChatTrigger.classList.contains('livechat__trigger--open')

          if (!livechatOpen) {
            //@ts-ignore
            // LC_API.open_chat_window();
            //@ts-ignore
            if (!LiveChatWidget.init()) {
              //@ts-ignore
              // LC_API.open_chat_window();
              //@ts-ignore
              LiveChatWidget.init()
              // this.el.text.innerHTML = dictionary('chaChatContinue')
            }

            //@ts-ignore
            // LC_API.open_chat_window();
            //@ts-ignore
          }

          //@ts-ignore
          // LC_API.open_chat_window();
          //@ts-ignore
          LiveChatWidget.call('maximize')

          if (!livechatOpen) {
            this.el.liveChatTrigger.classList.add('livechat__trigger--open')
          }
        })
      }
    }
  },
}

export default ChatBubble
